<template>
  <b-form-group>
    <b-card header="Settings">
      <b-form-group>
        <b-checkbox :disabled="readonly" v-model="settings.active" :value="1" :unchecked-value="0">
          Active
        </b-checkbox>
        <b-form-invalid-feedback v-if="formErrors && formErrors.active && formErrors.active.length > 0" :state="false">
          <p v-for="(e, $index) in formErrors.active" :key="$index">{{ e }}</p>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Rotation:" :disabled="readonly">
        <b-form-radio v-model="settings.rotation" value="0">0</b-form-radio>
        <b-form-radio v-model="settings.rotation" value="90">90</b-form-radio>
        <b-form-radio v-model="settings.rotation" value="270">-90</b-form-radio>
        <b-form-radio v-model="settings.rotation" value="180">180</b-form-radio>
        <b-form-invalid-feedback v-if="formErrors && formErrors.rotation && formErrors.rotation.length > 0"
          :state="false">
          <p v-for="(e, $index) in formErrors.rotation" :key="$index">{{ e }}</p>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
        <b-checkbox :disabled="readonly" v-model="settings.play_old" :value="1" :unchecked-value="0">
          Play old playlist when playlist update fails
        </b-checkbox>
        <b-form-invalid-feedback v-if="formErrors && formErrors.play_old && formErrors.play_old.length > 0"
          :state="false">
          <p v-for="(e, $index) in formErrors.play_old" :key="$index">{{ e }}</p>
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- <b-form-group label="Volume:">
        <b-form-input :disabled="readonly" v-model="settings.volume" :type="'range'" required placeholder="Volume"/>
        <div class="my-2">Value: {{ settings.volume }}</div>
        <b-form-invalid-feedback
          v-if="formErrors && formErrors.volume && formErrors.volume.length > 0" :state="false">
          <p v-for="(e, $index) in formErrors.volume" :key="$index">{{e}}</p>
        </b-form-invalid-feedback>
      </b-form-group> -->

      <!-- <b-form-group label="Rotation:">
        <b-form-select :disabled="readonly" v-model="settings.rotation" required>
            <option v-for="(value, $index) in rotationValues" :value="value" :key="$index">{{value}}</option>
          </b-form-select>
        <b-form-invalid-feedback
          v-if="formErrors && formErrors.rotation && formErrors.rotation.length > 0" :state="false">
          <p v-for="(e, $index) in formErrors.rotation" :key="$index">{{e}}</p>
        </b-form-invalid-feedback>
      </b-form-group> -->

      <b-form-group label="Check interval (seconds):">
        <b-form-input :disabled="readonly" v-model="settings.check_interval" type="number" required
          placeholder="Interval in seconds" />
        <b-form-invalid-feedback v-if="formErrors && formErrors.check_interval && formErrors.check_interval.length > 0"
          :state="false">
          <p v-for="(e, $index) in formErrors.check_interval" :key="$index">{{ e }}</p>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Current playlist info">
        <span v-if="settings.playlist">Playlist: {{ settings.playlist.name || 'none' }}</span>
        <span v-if="settings.loop_playlist">Looped Playlist: {{ settings.loop_playlist.name || 'none' }}</span>
        <span v-if="settings.weekly_playlist">Weekly Playlist: {{ settings.weekly_playlist.name || 'none' }}</span>
        <b-button v-if="!readonly" @click="pickPlaylist('playlists');" type="button" variant="success"
          class="mx-2">Choose a Playlist</b-button>
        <b-button v-if="!readonly" @click="pickPlaylist('loop-playlists');" type="button" variant="warning"
          class="mx-2">Choose a Looped Playlist</b-button>
        <b-button v-if="!readonly" @click="pickPlaylist('weekly-playlists');" type="button" variant="warning"
          class="mx-2">Choose a Weekly Playlist</b-button>
        <b-form-invalid-feedback v-if="formErrors && formErrors.playlist_id && formErrors.playlist_id.length > 0"
          :state="false">
          <p v-for="(e, $index) in formErrors.playlist_id" :key="$index">{{ e }}</p>
        </b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="formErrors && formErrors.loop_playlist_id && formErrors.loop_playlist_id.length > 0" :state="false">
          <p v-for="(e, $index) in formErrors.loop_playlist_id" :key="$index">{{ e }}</p>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Business hours" v-if="typeof settings.business_hours === 'object'">
        <b-row v-for="day in settings.business_hours" :key="day.dayNo">
          <b-col cols="12" sm="4" class="my-1">
            <b-checkbox :disabled="readonly" v-model="day.active" :value="true" :unchecked-value="false">
              {{ day.day }}
            </b-checkbox>
          </b-col>
          <b-col cols="12" sm="4" class="my-1">
            <datetime :disabled="readonly || !day.active" v-model="day.hoursStart" :type="'time'"
              :input-class="'form-control'"></datetime>
          </b-col>
          <b-col cols="12" sm="4" class="my-1">
            <datetime :disabled="readonly || !day.active" v-model="day.hoursEnd" :type="'time'"
              :input-class="'form-control'"></datetime>
          </b-col>
        </b-row>
      </b-form-group>

      <!-- <b-form-group>
        <date-picker v-model="date" :config="options"></date-picker>
      </b-form-group>
 -->
    </b-card>
  </b-form-group>
</template>


<script>
import { Datetime } from 'vue-datetime';
import settingsMixin from '@/mixins/settings';

export default {
  components: { Datetime },
  mixins: [settingsMixin],
  props: {
    settingsObj: {
      type: [Object],
      required: true,
    },
    readonly: {
      type: [Boolean],
      required: false,
      default: false,
    },
    formErrors: {
      type: [Object, Array],
      required: false,
    },
  },
  watch: {
    settingsObj: {
      deep: true,
      handler(newData) {
        this.settings = newData;
      },
    },
  },
  data() {
    return {
      settings: null,
      rotationValues: [0, 90, 180, 270],
      dtpOptions: {
        format: 'HH:mm',
      },
    };
  },
  created() {
    this.settings = this.settingsObj;
  },
  methods: {
    pickPlaylist(playlistType) {
      this.$root.$emit('modal-show-playlist-picker', {
        title: 'Choose a playlist',
        body: '',
        cbConfirm: (playlist) => {
          this.$set(this.settings, 'playlist', null);
          this.$set(this.settings, 'playlist_id', null);
          this.$set(this.settings, 'loop_playlist', null);
          this.$set(this.settings, 'loop_playlist_id', null);
          this.$set(this.settings, 'weekly_playlist', null);
          this.$set(this.settings, 'weekly_playlist_id', null);
          if (playlistType === 'playlists') {
            this.$set(this.settings, 'playlist', playlist);
            this.$set(this.settings, 'playlist_id', playlist.id);
          } else if (playlistType === 'loop-playlists') {
            this.$set(this.settings, 'loop_playlist', playlist);
            this.$set(this.settings, 'loop_playlist_id', playlist.id);
          } else if (playlistType === 'weekly-playlists') {
            this.$set(this.settings, 'weekly_playlist', playlist);
            this.$set(this.settings, 'weekly_playlist_id', playlist.id);
          }
        },
        cancelText: 'Cancel',
        playlistPicker: true,
        playlistType,
        orientation: this.settings.rotation === '90' || this.settings.rotation === '270' ? 1 : 0,
      });
    },
  },
};
</script>
